import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { LoaderView } from "../../loader/loader.comp";
import NotFound from "../../../views/not-found/not-found";

const ManagerProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { user, isAdmin } = FirebaseAuthContainer.useContainer();

    return user ? isAdmin ? children : <NotFound /> : <LoaderView show={true} />;
};

export default ManagerProtectedRoute;
